import { render } from "./EmployeeAdmin.vue?vue&type=template&id=39014384&scoped=true"
import script from "./EmployeeAdmin.vue?vue&type=script&lang=js"
export * from "./EmployeeAdmin.vue?vue&type=script&lang=js"

import "./EmployeeAdmin.vue?vue&type=style&index=0&id=39014384&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39014384"]])

export default __exports__